'use strict';

function VerifyAccount() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this._email_address = null;
  this.extends = [_AccountController];
  this.clickCount = 0;
  this.disableDialog = false;

  this.elements = {};

  this.init = function () {
    this._super();
    this._email_address = this.presenter.models.account.email_address;
    $('#email').text(this._email_address);
    // Bind event when click resent-email-btn
    $('.js--resend-email-btn').on('click', $.proxy(this._resendAccountEmail, this));

    this.contentfulService = this.node.querySelector('[data-mogo-ui=ContentfulService]');

    if (this.contentfulService) {
      this.contentfulDataLoaded = this.contentfulService.mogo().contentLoadedPromise;

      var requiredContentPath = this._getPageContentRefString();
      var requiredContent = this.presenter.getModelProperty(requiredContentPath);

      if (typeof requiredContent === 'undefined') {
        // Wait until contentful data is loaded
        $.when(this.contentfulDataLoaded).then(this._onContentfulLoaded.bind(this));
      } else {
        this._onContentfulLoaded();
      }
    }
  };

  this.initAllReady = function () {
    this._super();

    if (this.hasVerifiedEmail()) {
      this.routeToNextStep();
      return;
    }

    this.analytics.pushEvent('virtual-page-view');
  };

  this._onContentfulLoaded = function () {
    // Set requiredContent when contentfulLoaded is ready
    this.requiredContentPath = this._getPageContentRefString();
    this.requiredContent = this.presenter.getModelProperty(this.requiredContentPath);

    if (!this.requiredContent) console.warn('VerifyAccount.js: unable to retrieve content model for ' + this.requiredContentPath);

    // Cache selectors
    this.elements.header = this.node.querySelector('.js--verify-account-header');
    this.elements.description = this.node.querySelector('.js--verify-account-description');

    // Cache contentful response
    var contentfulObject = this.presenter.getModelProperty(this.requiredContentPath);

    var VerifyEmailA = contentfulObject.VerifyEmailA;

    // Update node html with contentful response

    if (this.elements.header && this.elements.description) {
      this.elements.header.innerHTML = VerifyEmailA.header;
      this.elements.description.innerHTML = this.parseUserEmail(VerifyEmailA.bodyContent);
    }
  };

  /*
    Replaces content in square brackets with user email
    ex: [user_email] -> useremail@useremail.com
  */
  this.parseUserEmail = function (textContainingEmail) {
    return textContainingEmail.replace(/\[(.+?)\]/g, '<b>' + this._email_address + '</b>');
  };

  this._resendAccountEmail = function () {
    if (!this.disableDialog) {
      this.clickCount += 1;
      // Show confirmation verify email dialog if user clicks
      // this button 3 times
      if (this.clickCount === 3) {
        this._activateVerifyEmailDialog();
      }
    }
    if (this._email_address !== null) {
      var data = {
        email_address: this._email_address
      };
      var request = new APIRequest('/accounts/resend_activation', 'POST', data, $.proxy(this._onEmailSent, this));
      request.send();
      this._toggleResend();
    }
  };

  this._setDialogBindings = function () {
    var _this = this;

    this._verifyEmailDialog = document.getElementById('verify-email-dialog');
    var _dialogContent = this._verifyEmailDialog.getElementsByClassName('js--boolean-dialog-content')[0];
    var _confirmCta = this._verifyEmailDialog.getElementsByClassName('js--confirm-dialog-cta')[0];
    var _editCta = this._verifyEmailDialog.getElementsByClassName('js--edit-dialog-cta')[0];
    var _closeButton = this._verifyEmailDialog.getElementsByClassName('icon--close')[0];

    /*
      Allow for data-bind properties (account.email_address) to be loaded 
      and accessible since this Dialog component is created dynamically. 
      Also make CTAs rely on history object so don't force page reload on click.
    */
    this.presenter.scanDOM(this._verifyEmailDialog);
    _dialogContent.mogo().parse();
    this.history.addHistoryNode(_confirmCta, _confirmCta.href);
    this.history.addHistoryNode(_editCta, _editCta.href);

    // Add bind events for edit, and confirm buttons.
    _editCta.addEventListener('click', function () {
      _this._verifyEmailDialog.mogo().hide();
    });

    /*
      Once the user clicks confirm or close, don't show dialog again
    */
    _confirmCta.addEventListener('click', function () {
      _this._verifyEmailDialog.mogo().hide();
      _this.disableDialog = true;
    });

    _closeButton.addEventListener('click', function () {
      _this._verifyEmailDialog.mogo().hide();
      _this.disableDialog = true;
    });
  };

  /*
     This is the callback passed into onUrlLoaded variable, 
     gets called when the Dialog component is loaded
     See: localhost/docs/ui-components#!Dialog 
    */
  this._onVerifyEmailDialogLoaded = function () {
    // Set bindings
    this._setDialogBindings();

    // Show Dialog
    this._verifyEmailDialog.mogo().show();
  };

  this._activateVerifyEmailDialog = function () {
    /*
     Dynamically create Dialog component if not already created, else show it
    */

    if (!document.getElementById('verify-email-dialog')) {
      $('<div></div>').mogo().create('Dialog', {
        id: 'verify-email-dialog',
        close: true,
        url: '/member/account/verify-email-dialog', // Pug file containing markup for dialog
        onUrlLoaded: this._onVerifyEmailDialogLoaded.bind(this), // Callback - See: localhost/docs/ui-components#!Dialog
        backgroundClose: false
      });
      this._verifyEmailDialog = document.getElementById('verify-email-dialog');
    } else {
      document.getElementById('verify-email-dialog').mogo().show();
    }
  };

  this._toggleResend = function () {
    $('#cant-find').toggle();
    $('#email-resent').toggle();
  };

  this._onEmailSent = function () {
    setTimeout(this._toggleResend, 10000);
  };

  /*  
    _getPageContentRefString: builds a reference string,
    this reference string is used in getModelProperty.
  */
  this._getPageContentRefString = function () {
    return 'content.pages.' + this.node.closest('[data-mogo-page]').dataset.mogoPage;
  };
}